<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-select icon="list_alt" v-model="form.type" :options="typeCodeSelect" v-if="typeCodeSelect">
        </trax-ui-select>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>
        
        <trax-ui-input type="text" icon="code" :placeholder="codeLabel"
            v-model="form.code" :error="errors.code" :rows="inputRows" v-if="withCode">
        </trax-ui-input>
        
        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description" :rows="3" v-if="withDescription">
        </trax-ui-input>
        
    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: null,
            endpoint: null,
            typeCode: null,
            typeCodeSelect: null,
            indexId: null,
            itemRows: null,
            withDescription: null,
            withCode: null,
            codeLabel: {default: lang.polaris.form.code},
            indexKey: { default: 'index_id' }
        },
    
        data: function() {
            var props = {
                id: { source:'id' },
                parent_id: { source:'parent_id' },
                type: { source:'type', default: this.typeCode },
                [this.indexKey]: { source: this.indexKey, default: this.indexId },
                order: { source:'order' },
                title: { source:'title' },
                name: { source:'name' }
            };
            if (this.withDescription) props.description = { source:'description' };
            if (this.withCode) props.code = { source:'code' };
            return {
                lang: lang,
                form: {},
                errors: {},
                props: props,
                titles: {
                    new: lang.polaris.form.new_item,
                    update: lang.polaris.form.item_update
                }
            }
        },

        computed: {

            inputRows: function() {
                if (this.form.parent_id && !this.form.title && this.itemRows) return this.itemRows;
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(this.id+'-data', function(data) {
                that.form = data;
            });
        }
    }
</script>
